import { render, staticRenderFns } from "./BasicSelect.vue?vue&type=template&id=314a62d4&"
import script from "./BasicSelect.vue?vue&type=script&lang=ts&"
export * from "./BasicSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BasicSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports